import { Link, useParams } from "react-router-dom";
import { BookOpen, ArrowLeft } from "lucide-react";
import { useApi } from "@/hooks/useApi";
import { ThemeToggle } from "@/components/layout/AppShell";
import { cn } from "@/lib/utils";

export default function Docs() {
  const { "*": path } = useParams();
  const current = path || "README.md";
  const { data: index } = useApi("/docs");
  const { data: doc, error } = useApi(`/docs/${current}`, [current]);
  const sections = (index?.items || []).reduce((acc, it) => ({ ...acc, [it.section]: [...(acc[it.section] || []), it] }), {});
  return (
    <div className="min-h-screen">
      <header className="h-16 border-b flex items-center justify-between px-6 lg:px-10 sticky top-0 z-20 backdrop-blur-md bg-white/90 dark:bg-slate-900/90">
        <div className="flex items-center gap-3"><Link to="/" className="text-sm flex items-center gap-1.5 text-muted-foreground hover:text-foreground" data-testid="docs-home"><ArrowLeft size={14} /> ComplyKosh</Link><span className="font-display font-bold flex items-center gap-2"><BookOpen size={16} /> Documentation</span></div>
        <div className="flex items-center gap-2">{index?.license && <span className="text-[11px] font-mono uppercase px-2 py-1 rounded-md border bg-muted" data-testid="docs-edition">{index.license.edition} edition</span>}<ThemeToggle /></div>
      </header>
      <div className="grid lg:grid-cols-[260px_1fr] max-w-7xl">
        <aside className="border-r p-6 space-y-5 lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)] overflow-y-auto" data-testid="docs-nav">
          {Object.entries(sections).map(([sec, items]) => <div key={sec}><div className="eyebrow mb-2 capitalize">{sec}</div><ul className="space-y-0.5">{items.map((it) => <li key={it.path}><Link to={`/docs/${it.path}`} data-testid={`doc-link-${it.path.replace(/[^a-zA-Z0-9]/g, "-")}`} className={cn("block text-sm px-2 py-1 rounded-md row-hover", current === it.path && "bg-primary/10 text-primary font-medium")}>{it.title}</Link></li>)}</ul></div>)}
        </aside>
        <main className="p-6 lg:p-12 min-w-0">
          {error ? <div className="text-muted-foreground" data-testid="doc-missing">Document not found.</div> : doc ? <article className="prose prose-slate dark:prose-invert max-w-none doc-body" data-testid="doc-body" dangerouslySetInnerHTML={{ __html: doc.html }} /> : null}
        </main>
      </div>
    </div>
  );
}
